import { createAxiosClient } from '../axiosDefaults';
export function createApi(config) {
  let axiosConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const instance = createAxiosClient({
    baseURL: config.baseApiUrl,
    withCredentials: true,
    ...axiosConfig
  }, config);

  function getAreas(country) {
    return instance.get('/branch/area', {
      params: {
        country
      }
    });
  }

  return {
    getAreas
  };
}